import React, { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import Header from "../Header";
import Footer from "../Footer";
import ScrollToTop from "../ScrollToTop";
import LoadingSpinner from "../LoadingSpinner";
import PageSeo from "../PageSeo";

const Layout = ({ children, seo }) => {
  return (
    <>
      <PageSeo seo={seo} />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 2200,
          style: {
            borderRadius: "14px",
            background: "#ffffff",
            color: "#111827",
            fontSize: "13px",
            fontWeight: 600,
            padding: "10px 16px",
            boxShadow: "0 16px 30px rgba(17, 24, 39, 0.12)",
            border: "1px solid rgba(17, 24, 39, 0.08)",
          },
          success: {
            style: {
              background: "#ffffff",
            },
          },
        }}
      />
      <ScrollToTop />
      <Header />
      <Suspense fallback={<LoadingSpinner className="spinner-container--page" />}>
        {children}
      </Suspense>
      <Footer />
    </>
  );
};

export default Layout;
